import { getUserPaymentOptions } from "@/features/users/users.queries";
import { Payment } from "@/pages/Payment";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/payment")({
  loader: async ({ context }) => {
    const { queryClient } = context;
    try {
      await queryClient.ensureQueryData(
        getUserPaymentOptions({ staleTime: 5000 }),
      );
    } catch (error) {
      throw redirect({
        to: "/login",
        search: { msg: `Session Expire Pls Login again` },
      });
    }
  },
  component: Payment,
});
